export default __webpack_public_path__ + "static/media/illustration_step1_howItWorks.8a23ee01.png";